function nextStep(lastStep?: string) {
  switch (lastStep ?? "default") {
    case "step1":
      return "step2";
    case "step2":
      return "step3";
    case "step3":
      return "thank-you";
    default:
      return "apply-now";
  }
}

export default {
  nextStep,
};
